import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import {
    FiTooltipButtonIconColors,
    FiTooltipIconClassType,
} from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.component';
import { FiInfoIconMode } from '@fi-shared/info-icon/info-icon.component';
import { FiAutomatedActionBase } from '../../../../../../automated-action-list-item/automated-action-base.directive';
import { CheckpointActionRecipientType } from '../../../../../checklist-enum';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

@Component({
    selector: 'fi-deviation-task-list-item',
    templateUrl: './deviation-task-list-item.component.html',
    styleUrls: ['./deviation-task-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-deviation-task-list-item' },
    standalone: false,
})
export class FiDeviationTaskListItemComponent extends FiAutomatedActionBase {
    @Input() isPrivateTask: boolean;
    @Input() taskName: string;
    @Input() taskDeadline: string;

    ngOnInit() {
        super.ngOnInit();
        this.setServices();
    }

    getTaskTargetLabel(): string {
        return this.appTextService
            .get(this.isPrivateTask ? 'task.assigned_to' : 'task.assigned_to_selected')
            .toLowerCase();
    }

    getTaskTargetItemsLabel(): string {
        if (this.isAssignedToColleagues()) return this.appTextService.get('common.staff_members').toLowerCase() + '.';
        return this.appTextService.get('common.roles').toLowerCase();
    }

    getAssignedUserName(): string {
        return this.fiUserDataService.getUserProfile().FullName;
    }

    isAssignedToColleagues(): boolean {
        return !this.isPrivateTask && this.recipientType === CheckpointActionRecipientType.Users;
    }

    private fiUserDataService: FiUserDataService;
    private setServices() {
        this.fiUserDataService = this.injector.get(FiUserDataService);
    }

    protected readonly FiTooltipButtonIconColors = FiTooltipButtonIconColors;
    protected readonly FiInfoIconMode = FiInfoIconMode;
    protected readonly FiTooltipIconClassType = FiTooltipIconClassType;
}
